var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { professionalStatusEntityName } from '../../../../../../backend/config/classifiers/entities/defineProfessionalStatusClassifier';
import { PublicDataClient } from '@juvare/platform-sdk-js/PublicDataClient';
export const buildProfessionalStatusValueProvider = (appName) => {
    const publicData = new PublicDataClient(appName);
    return {
        type: `classifier.${professionalStatusEntityName}`,
        label: 'Professional Status',
        disableCache: true,
        getValues: (params) => __awaiter(void 0, void 0, void 0, function* () {
            const publicProfessionalStatuses = yield publicData.publicDataGetObject(`classifier-${professionalStatusEntityName}`);
            publicProfessionalStatuses.sort((a, b) => {
                if ((a === null || a === void 0 ? void 0 : a.displayOrder) === undefined)
                    return 1;
                if ((b === null || b === void 0 ? void 0 : b.displayOrder) === undefined)
                    return -1;
                return a.displayOrder - b.displayOrder;
            });
            if (!(typeof params === 'string'))
                return publicProfessionalStatuses;
            return publicProfessionalStatuses.filter((value) => value.occupationGroupIds.includes(params));
        }),
    };
};
